import axios from 'axios';

const instance = axios.create({
    // Staging
    // baseURL: 'https://api-runsmart-dropship.mmandb-staging.co.uk',
    // Production
    baseURL: 'https://api.customisedclothing.com',
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios.js